import { elementBrowserPmKey } from './elementBrowser';

/**
 * For insert menu in right rail experiment
 * - Clean up ticket ED-24801
 */
export var toggleInsertMenuRightRail = function toggleInsertMenuRightRail(tr) {
  return tr.setMeta(elementBrowserPmKey, {
    update: true
  });
};